module.exports = __webpack_public_path__ + "img/125.c457d434.jpg";